import _extends from "@babel/runtime/helpers/extends";
import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.5 12a1.5 1.5 0 0 0-.83.25 1.55 1.55 0 0 0-.56.68 1.49 1.49 0 0 0-.08.86A1.49 1.49 0 0 0 6.21 15a1.49 1.49 0 0 0 .86-.08 1.55 1.55 0 0 0 .68-.56A1.5 1.5 0 0 0 6.5 12zm0 2a.54.54 0 0 1-.28-.08.58.58 0 0 1-.22-.23.48.48 0 0 1 0-.29.53.53 0 0 1 .4-.4.48.48 0 0 1 .29 0 .58.58 0 0 1 .23.18.54.54 0 0 1 .08.32.51.51 0 0 1-.5.5zm7.5-.5a1.5 1.5 0 0 0-.25-.83 1.55 1.55 0 0 0-.68-.56 1.49 1.49 0 0 0-.86-.08A1.49 1.49 0 0 0 11 13.21a1.49 1.49 0 0 0 .08.86 1.55 1.55 0 0 0 .56.68A1.5 1.5 0 0 0 14 13.5zm-2 0a.54.54 0 0 1 .08-.28.58.58 0 0 1 .23-.18.48.48 0 0 1 .29 0 .53.53 0 0 1 .39.39.48.48 0 0 1 0 .29.58.58 0 0 1-.18.23.54.54 0 0 1-.28.08.51.51 0 0 1-.5-.5zM.5 1h2L5 10.63a.5.5 0 0 0 .18.27.51.51 0 0 0 .3.1h8a.5.5 0 0 0 0-1H5.8l-.3-1.1 9-.4a.56.56 0 0 0 .31-.12.56.56 0 0 0 .19-.29l1-5.5a.41.41 0 0 0 0-.22.39.39 0 0 0-.1-.19.37.37 0 0 0-.17-.13.5.5 0 0 0-.21 0H3.7L3.31.37A.5.5 0 0 0 3.13.1a.51.51 0 0 0-.3-.1H.5a.47.47 0 0 0-.35.15A.47.47 0 0 0 0 .5a.47.47 0 0 0 .15.35A.47.47 0 0 0 .5 1zM15 3l-.9 4.5-8.8.41L4 3z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 16 16"
  }, props), _ref);
};

export default SvgComponent;